/**
 * Page views, reported as requests the edge can log.
 *
 * The site routes in the browser, so CloudFront sees a request only when a
 * reader arrives or reloads; a reader who walks from an organization to its
 * funder to a map fetches those pages from the API, which CloudFront never
 * sees. On every navigation the site therefore asks CloudFront for
 * `/_view/<page>`, and the edge function answers with nothing. The request is
 * logged with the page in its path, and the log is written without the
 * reader's address (the terms page says what it holds). Only the pathname is
 * sent: never a query string, a fragment, or anything typed into the search
 * box, which goes to the API and not into a path.
 */

/** The longest path reported; a longer one is a mistake or an attack, and the log is not the place for either. */
export const VIEW_PATH_LIMIT = 200;
export const VIEW_PREFIX = '/_view';

export const viewPath = (pathname: string): string => `${VIEW_PREFIX}${pathname.slice(0, VIEW_PATH_LIMIT)}`;

const send = (path: string): Promise<unknown> => fetch(path, { method: 'GET', cache: 'no-store', keepalive: true, credentials: 'omit' });

/** Fire and forget: a view that is not logged is not an error anyone should see. */
export const reportView = (pathname: string, sender: (path: string) => Promise<unknown> = send): void => {
  try {
    void sender(viewPath(pathname)).catch(() => undefined);
  } catch {
    // A browser without fetch, or a blocked request, loses one line of a log.
  }
};
